import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { hexToRgba } from '../../../common/formatters/colorFormatter';
import { GeometryExact } from '../../models/Geometry';

const HyspexCoverage = ({ index, geometry, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: visible ? geometry : undefined,
    }),
    [visible, geometry]
  );

  return (
    <GeoJSONLayer
      id={`hyspex-coverage${index}`}
      data={sourceData}
      fillPaint={{
        'fill-color': hexToRgba(theme.palette.map.hyspexCoverage, 0.6),
        'fill-outline-color': theme.palette.map.hyspexCoverage,
      }}
    />
  );
};

HyspexCoverage.propTypes = {
  geometry: GeometryExact,
  index: PropTypes.number,
  visible: PropTypes.bool,
};

HyspexCoverage.defaultProps = {
  geometry: undefined,
  index: 0,
  visible: true,
};

export default React.memo(HyspexCoverage);
